export const validateCAPostalCode = (postalCode: string) => {
	// regex to match valid canadian postal codes
	const canadaRegex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
	const validCAPostalCode = postalCode.match(canadaRegex);
	const country = validCAPostalCode ? "CANADA" : "US";
	return country;
}